import {
  SOAP_FIELDS,
  TEMPLATE_FIELDS,
  TEMPLATE_TYPES,
} from "../constants";

export const cleanExtractedData = (data) => ({
  [TEMPLATE_FIELDS.SUBJECTIVE]:
    data[TEMPLATE_FIELDS.SUBJECTIVE]?.trim() || "",
  [TEMPLATE_FIELDS.OBJECTIVE]:
    data[TEMPLATE_FIELDS.OBJECTIVE]?.trim() || "",
  [TEMPLATE_FIELDS.ASSESSMENT]:
    data[TEMPLATE_FIELDS.ASSESSMENT]?.trim() || "",
  [TEMPLATE_FIELDS.PLAN]: data[TEMPLATE_FIELDS.PLAN]?.trim() || "",
  [TEMPLATE_FIELDS.CUSTOM]:
    data[TEMPLATE_FIELDS.CUSTOM]?.trim() || "",
});

export const processField = (fieldName, fieldValue, fieldIdx) => ({
  fieldName,
  fieldValue,
  fieldIdx,
});

export const processSoapFields = (trimmedData) => {
  return [
    processField(
      TEMPLATE_FIELDS.SUBJECTIVE,
      trimmedData[TEMPLATE_FIELDS.SUBJECTIVE],
      0,
    ),
    processField(
      TEMPLATE_FIELDS.OBJECTIVE,
      trimmedData[TEMPLATE_FIELDS.OBJECTIVE],
      1,
    ),
    processField(
      TEMPLATE_FIELDS.ASSESSMENT,
      trimmedData[TEMPLATE_FIELDS.ASSESSMENT],
      2,
    ),
    processField(
      TEMPLATE_FIELDS.PLAN,
      trimmedData[TEMPLATE_FIELDS.PLAN],
      3,
    ),
  ];
};

export const isPreviewDisabled = (formData, dirtyFields) => {
  const keysDirty = Object.keys(dirtyFields).length > 0;

  let templateFieldsNotEmpty = false;

  if (formData.templateType === TEMPLATE_TYPES.SOAP) {
    // for each field in soap fields, check if the field is not empty
    SOAP_FIELDS.forEach((field) => {
      if (formData[field.fieldName] !== "") {
        templateFieldsNotEmpty = true;
      }
    });
  }

  if (formData.templateType === TEMPLATE_TYPES.CUSTOM) {
    // for the custom field in the soap template, check if the field is not empty
    formData.templateFields.forEach((field) => {
      if (field.fieldValue !== "") {
        templateFieldsNotEmpty = true;
      }
    });
  }

  return !keysDirty || !templateFieldsNotEmpty;
};

export const processCustomFields = (content) => {
  return [processField(TEMPLATE_FIELDS.CUSTOM, content, 0)];
};
